import {
  FormTokenChainState,
  FormTokenMetaRecord,
  TokenId,
} from '../types/context';

type FormTokensMetaDiff = {
  changedRecords: FormTokenMetaRecord[];
  removedIds: TokenId[];
};

// Reference comparison is enough: chain mutations spread-copy only the touched nodes
export const diffFormTokensMeta = (
  previousNodes: FormTokenChainState['nodes'],
  nextNodes: FormTokenChainState['nodes']
): FormTokensMetaDiff => {
  const changedRecords: FormTokenMetaRecord[] = [];
  Object.values(nextNodes).forEach((node) => {
    if (node.meta && previousNodes[node.id]?.meta !== node.meta) {
      changedRecords.push({ id: node.id, meta: node.meta });
    }
  });

  const removedIds = Object.keys(previousNodes).filter(
    (nodeId) => previousNodes[nodeId].meta && !nextNodes[nodeId]?.meta
  );

  return { changedRecords, removedIds };
};
